// @flow
import React, { useState } from "react";
import { Row, Col, Button } from "react-bootstrap";
import ImprintModal from "../components/LegalModals/ImprintModal";
import PrivacyModal from "../components/LegalModals/PrivacyModal";
import TermsOfUseModal from "../components/LegalModals/TermsOfUseModal";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();

  const [showImprintModal, setShowImprintModal] = useState(false);
  const [showTermsOfUseModal, setShowTermsOfUseModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);
  const currentYear = new Date().getFullYear();
  return (
    <React.Fragment>
      <ImprintModal
        hideModal={() => {
          setShowImprintModal(false);
        }}
        showModal={showImprintModal}
      />
      <PrivacyModal
        hideModal={() => {
          setShowPrivacyModal(false);
        }}
        showModal={showPrivacyModal}
      />
      <TermsOfUseModal
        hideModal={() => {
          setShowTermsOfUseModal(false);
        }}
        showModal={showTermsOfUseModal}
      />
      <footer className="footer">
        <div className="container-fluid">
          <Row>
            <Col md={6} className="align-content-center">
              {currentYear} ©{" "}
              {t("Copyright Line Up Handels GmbH. All Rights reserved.")}
            </Col>

            <Col md={6}>
              <div className="text-md-end footer-links d-none d-md-block">
                <Button
                  variant="link"
                  className="footer-link"
                  onClick={() => {
                    setShowImprintModal(true);
                  }}
                >
                  {t("Imprint")}
                </Button>
                <Button
                  variant="link"
                  className="footer-link"
                  onClick={() => {
                    setShowTermsOfUseModal(true);
                  }}
                >
                  {t("Terms of Use")}
                </Button>
                <Button
                  variant="link"
                  className="footer-link"
                  onClick={() => {
                    setShowPrivacyModal(true);
                  }}
                >
                  {t("Privacy Policy")}
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
